"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const striptags_1 = __importDefault(require("striptags"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const SuluNewsTeaser_1 = __importDefault(require("../../stores/SuluNewsTeaser"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const NewsTeaserTile_1 = __importDefault(require("./NewsTeaserTile"));
class NewsTeaser extends react_1.default.Component {
    pageNumber = 1;
    pageSize = 1;
    screenWidth = screen.availWidth ?? screen.width;
    pageSizePrev = 1;
    newsReacitonDisposer;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            pageNumber: mobx_1.observable,
            pageSize: mobx_1.observable,
            screenWidth: mobx_1.observable,
            items: mobx_1.computed,
            prevButtonDisabled: mobx_1.computed,
            nextButtonDisabled: mobx_1.computed,
            setPageSize: mobx_1.action.bound,
            onClickPrev: mobx_1.action.bound,
            onClickNext: mobx_1.action.bound,
            calculatePaginationNewsTeaser: mobx_1.action.bound,
        });
    }
    get items() {
        return SuluNewsTeaser_1.default.get(UiStore_1.default.language) ?? [];
    }
    get prevButtonDisabled() {
        return this.pageNumber === 1;
    }
    get nextButtonDisabled() {
        return this.items.length - this.pageNumber * this.pageSize <= 0;
    }
    componentDidMount() {
        this.newsReacitonDisposer = (0, mobx_1.reaction)(() => [AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.NEWS_READ), AuthorizationStore_1.default.industryId], ([hasAccess, industryId]) => {
            if (hasAccess && typeof industryId === 'string') {
                SuluNewsTeaser_1.default.loadNewsTeaserItems(UiStore_1.default.language, industryId);
            }
        }, { fireImmediately: true });
        window.addEventListener('resize', this.calculatePaginationNewsTeaser);
    }
    componentDidUpdate() {
        this.calculatePaginationNewsTeaser();
    }
    componentWillUnmount() {
        this.newsReacitonDisposer?.();
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null, this.items.length > 0 ? (react_1.default.createElement("section", { className: "znd-dashboard-news" },
            react_1.default.createElement("div", { className: "znd-dashboard-news__subtitle t-body-tiny" }, (0, translation_1.t)('dashboard.news.subtitle')),
            react_1.default.createElement("div", { className: "znd-dashboard-news__list-container" },
                react_1.default.createElement(Button_1.default, { className: 'znd-dashboard-news__slide-prev', variant: ButtonVariant_1.default.navigator, icon: Zupicons_1.default.angleLeft, onClick: this.onClickPrev, disabled: this.prevButtonDisabled }),
                react_1.default.createElement("div", { className: "znd-dashboard-news__list row align-items-stretch" }, this.items
                    .filter((item, index) => this.newsTeaserItemEnabled(index))
                    .map((item, index) => (react_1.default.createElement(NewsTeaserTile_1.default, { key: index, image: item.image ?? null, shortText: (0, string_1.decodeHtmlEntities)((0, striptags_1.default)(item.shortText ?? '')), title: item.title, url: item.url })))),
                react_1.default.createElement(Button_1.default, { className: 'znd-dashboard-news__slide-next', variant: ButtonVariant_1.default.navigator, icon: Zupicons_1.default.angleRight, onClick: this.onClickNext, disabled: this.nextButtonDisabled })))) : null));
    }
    newsTeaserItemEnabled(index) {
        return Math.ceil((index + 1) / this.pageSize) === this.pageNumber;
    }
    setPageSize() {
        if (window.matchMedia('(min-width: 1200px)').matches) {
            this.pageSize = 4;
            return;
        }
        if (window.matchMedia('(min-width: 768px)').matches) {
            this.pageSize = 3;
            return;
        }
        if (window.matchMedia('(min-width: 576px)').matches) {
            this.pageSize = 2;
            return;
        }
        this.pageSize = 1;
    }
    onClickPrev() {
        this.pageNumber = Math.max(this.pageNumber - 1, 1);
    }
    onClickNext() {
        this.pageNumber = Math.min(this.pageNumber + 1, Math.ceil(this.items.length / this.pageSize));
    }
    calculatePaginationNewsTeaser() {
        this.setPageSize();
        if (this.pageSize !== this.pageSizePrev) {
            this.pageSizePrev = this.pageSize;
            this.pageNumber = 1;
        }
    }
}
exports.default = (0, mobx_react_1.observer)(NewsTeaser);
